import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'allas-bottom-footer',

  imports: [CommonModule],
  templateUrl: 'bottom-footer.html',
})
export class BottomFooterComponent {
  @Input() currentYear: number = new Date().getFullYear();
  @Input() legal: any[] = [];
}
